// @flow
import './index.less'

import { Icon, Modal, Tabs } from 'antd'

import Button from '~button'
// Partials
import LoginForm from '../../../components/login-form'
import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import RegisterForm from '../../../components/register-form'
import { RouterHistory } from 'react-router-dom'
// Components
import Text from '~text'
import { Spin } from 'antd'
// Images
import logoImg from '~images/mudey-logo-white.png'
import { useTranslation } from 'react-i18next'
import { HAS_USER_LOGGED_OUT, SET_PATH_TO_REDIRECT } from '../../../store/actions'

const { TabPane } = Tabs

const options = {
  closable: false,
  footer: null
}

type PropsType = {
  history: RouterHistory,
  redirectTo: string,
  show: boolean,
  onClose: () => void
}

const LoginSignupPopup = ({ history, redirectTo, show, onClose }: PropsType) => {
  const dispatch = useDispatch()
  // const isAuthenticated = useSelector((state: any) => state.isAuthenticated)
  const { t } = useTranslation()
  let pathname = useSelector((state: any) => state.pathToRedirect)
  const [activeTab, setActiveTab] = useState('1')

  const handleClose = () => {
    dispatch({ type: SET_PATH_TO_REDIRECT, payload: null })
    localStorage.removeItem('pathToRedirect')
    onClose()
  }

  useEffect(() => {
    if (performance.navigation.type == 1) {
      dispatch({ type: SET_PATH_TO_REDIRECT, payload: null })
      localStorage.removeItem('pathToRedirect')
    }
  }, [])

  const isLoading = useSelector((state: any) => state.isLoading)
  return (
    <Modal
      centered
      className="login_register__popup"
      closable={options.closable}
      footer={options.footer}
      visible={show}>
      <Button onClick={() => handleClose()} type="link">
        &times;
      </Button>
      <div className="sections section-left">
        <Button onClick={() => handleClose()} type="link">
          ← Voltar
        </Button>
        <img alt="Mudey" className="mt-3 mb-2" src={logoImg} />
        <Text color="#FFF" margin="0px 0px 10px 0px" size={26}>
          Cria ou acede à tua conta!
        </Text>
        <Text color="#FFF" size={14}>
          Vamos guardar a tua simulação para que possas voltar sempre que quiseres
        </Text>
      </div>
      <div className="sections section-right">
        {!isLoading ? (
          <Tabs defaultActiveKey={activeTab} size="large">
            <TabPane
              key="1"
              tab={
                <span>
                  <Icon type="edit" /> {t('signup.title')}
                </span>
              }>
              <div className="py-2 px-4" onClick={() => setActiveTab('1')}>
                <RegisterForm
                  history={history}
                  onRegister={() => {
                    window.dataLayer = window.dataLayer || []
                    window.dataLayer.push({
                      event: 'Register_User',
                      New_user_created: 'modal'
                    })
                    setTimeout(() => {
                      if (pathname) {
                        history.push(pathname)
                      } else {
                        history.push(redirectTo)
                      }
                      dispatch({ type: HAS_USER_LOGGED_OUT, payload: false })
                      // history.push(redirectTo)
                    }, 2000)
                    onClose()
                  }}
                />
              </div>
            </TabPane>
            <TabPane
              key="2"
              tab={
                <span>
                  <Icon type="key" /> {t('login.title')}
                </span>
              }>
              <div className="py-2 px-4" onClick={() => setActiveTab('2')}>
                <LoginForm
                  history={history}
                  onLogin={() => {
                    // setTimeout(() => {
                    dispatch({ type: 'SET_IS_LOADING', payload: false })
                    // let pathname = localStorage.getItem('pathToRedirect')
                    if (pathname) {
                      history.push(pathname)
                    } else {
                      history.push(redirectTo)
                    }
                    dispatch({ type: HAS_USER_LOGGED_OUT, payload: false })

                    // localStorage.removeItem('pathToRedirect')
                    // }, 1000)
                  }}
                />
              </div>
            </TabPane>
          </Tabs>
        ) : (
          <div className="main-spinner">
            <Spin size="large" />
          </div>
        )}
      </div>
    </Modal>
  )
}

export default LoginSignupPopup
